import { approveRequest, fetchApprovalQueue, rejectRequest } from '@/approvals/api'
import type { Board, Funnel } from '@/card/dealApi'
import { fetchFunnels } from '@/card/dealApi'
import { request } from '@/lib/api'
import { fetchFunnelConversion, fetchReceivables } from './api'

/**
 * Источники дашборда руководителя — только существующие API, ни одной своей цифры.
 *
 * Отдельный модуль ради одного: экран собирает пять источников из трёх разделов, и тест
 * подменяет их одним местом, а не тремя чужими модулями.
 */

/**
 * Доска воронки с порцией до 200 карточек на стадию.
 *
 * Застрявшие берутся с карточек доски: признак `stuck` считает сервер, тот же, что на доске
 * и в отчёте о застое. Порция больше обычной (30), потому что карточки идут по свежести
 * правки, а застрявшие — как раз давно не тронутые; что не поместилось, экран называет
 * вслух (`remaining`).
 */
export function fetchBoardForDashboard(funnelId: string, signal?: AbortSignal): Promise<Board> {
  return request<Board>(`/sales/funnels/${funnelId}/board?limit=200`, { signal })
}

export type { Board, Funnel }
export {
  approveRequest,
  fetchApprovalQueue,
  fetchFunnelConversion,
  fetchFunnels,
  fetchReceivables,
  rejectRequest,
}
